import React from 'react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  caption?: string;
  className?: string;
};
export function CTAButton({
  label,
  caption,
  className = ''
}: CTAButtonProps) {
  return <div className={`flex w-full flex-col items-center gap-3 ${className}`} data-id="element-82" data-mp="2kzg07f1g6whe">
      <a href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-lime px-5 py-5 text-center text-base font-extrabold uppercase leading-tight tracking-tight text-ink shadow-[0_16px_40px_-16px_rgba(143,209,79,0.9)] transition-[transform,background-color] duration-150 ease-out hover:bg-lime-bright active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-lime-bright sm:text-lg" data-id="element-83" data-mp="2fzbt2fmfje3u">
        <span className="h-2.5 w-2.5 shrink-0 rounded-full bg-ink/70 animate-pulseDot" aria-hidden="true" data-id="element-84" data-mp="3cqvulv98xni6" />
        <span data-id="element-85" data-mp="38pk0bcffge3n">{label}</span>
      </a>
      {caption ? <p className="max-w-md text-center text-[13px] font-medium leading-relaxed text-slate-400" data-id="element-86" data-mp="1996amwyqdpaa">
          {caption}
        </p> : null}
    </div>;
}